import React, { useCallback } from "react";
import AsyncSelect from "react-select/async";
import debounce from "lodash.debounce";

import { StyledCompactSelectWrapper } from "../CompactSelect/CompactSelect.styles";
import { CompactControlComponent } from "../CompactSelect/RCompactSelectDerived";
import CompactSearchProps from "./CompactSearch.types";
import {
    ClearIconComponent,
    ContainerComponent,
    DropdownIndicatorComponent,
    DropdownIndicatorComponentWrapper,
    InputComponent,
    NoOptionsMessageComponent,
    OptionComponent,
    PlaceholderComponent,
    SingleValueComponent,
    ValueComponent,
} from "../Select/RSelectDerived";

const CompactSearch = React.forwardRef(
    (props: CompactSearchProps, ref: any) => {
        const {
            id = props?.name,
            option = [],
            noOptionText,
            noOptionHandler,
            labelFormatter,
            isClearable = false,
            value = null,
            customDropDownIcon,
            customSeparatorIndicator,
            debounceDuration = 500,
            loadOptions,
            menuPosition = "absolute",
            ...restProps
        } = props;

        const debouncedFetchData = useCallback(
            debounce((query, cb) => {
                loadOptions?.(query, cb);
            }, debounceDuration),
            [],
        );

        const CustomDropdown = (dropdownProps: any) => (
            <DropdownIndicatorComponentWrapper {...dropdownProps}>
                {customDropDownIcon}
            </DropdownIndicatorComponentWrapper>
        );

        return (
            <StyledCompactSelectWrapper>
                <AsyncSelect
                    {...(restProps as any)}
                    ref={ref}
                    id={`${id}__container`}
                    inputId={`${id}__input`}
                    instanceId={id}
                    options={option}
                    loadOptions={debouncedFetchData}
                    components={{
                        DropdownIndicator:
                            customDropDownIcon != null
                                ? CustomDropdown
                                : DropdownIndicatorComponent,
                        SelectContainer: ContainerComponent,
                        Control: CompactControlComponent,
                        SingleValue: SingleValueComponent,
                        NoOptionsMessage: NoOptionsMessageComponent,
                        Option: OptionComponent,
                        Input: InputComponent,
                        IndicatorSeparator:
                            (customSeparatorIndicator as any) ?? null,
                        ValueContainer: ValueComponent,
                        Placeholder: PlaceholderComponent,
                        ClearIndicator: ClearIconComponent,
                        ...(props?.components as any),
                    }}
                    noOptionsMessage={
                        noOptionHandler ?? (() => noOptionText ?? null)
                    }
                    formatOptionLabel={labelFormatter as any}
                    isClearable={isClearable}
                    value={value}
                    menuPosition={menuPosition}
                />
            </StyledCompactSelectWrapper>
        );
    },
);

export default CompactSearch;
